<template>
  <div>
    <v-card-title class="newsfeed-header-title px-0">DOCUMENTS:</v-card-title>
    <v-divider></v-divider>
    <v-row>
      <v-col
        v-for="(document, i) in documents"
        :key="i"
        :cols="$vuetify.breakpoint.mdAndUp ? 9 : 12"
        :md="$vuetify.breakpoint.mdAndUp ? 2 : ''"
      >
        <v-list-item class="px-0 download-box">
          <v-list-item-content>
            <v-list-item-title
              class="document-title"
              :style="
                $vuetify.breakpoint.mdAndUp ? 'width: auto' : 'width: 100px'
              "
              v-text="document.name"
            >
            </v-list-item-title>
          </v-list-item-content>
          <v-list-item-avatar>
            <v-tooltip bottom :color="$vuetify.theme.themes.light.tooltipColor">
              <template v-slot:activator="{ on, attrs }">
                <a
                  ref="documents"
                  :href="document.url"
                  download
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon>mdi-arrow-collapse-down</v-icon>
                </a>
              </template>
              <span>Click here to download</span>
            </v-tooltip>
          </v-list-item-avatar>
        </v-list-item>
      </v-col>
      <v-spacer></v-spacer>
      <v-col
        v-if="documents.length > 1"
        :cols="$vuetify.breakpoint.mdAndUp ? 2 : 12"
      >
        <a>
          <v-card-title
            :class="
              $vuetify.breakpoint.mdAndUp
                ? 'newsfeed-header-title px-0 justify-end'
                : 'newsfeed-header-title px-0'
            "
          >
            <div class="download-all" @click="downloadAll">
              Download All
            </div>
          </v-card-title>
        </a>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import JSZip from "jszip";
import JSZipUtils from "jszip-utils";
import { saveAs } from "file-saver";

export default {
  name: "DocumentList",
  props: {
    documents: Array,
    newsFeedData: Object
  },
  methods: {
    downloadAll() {
      var urls = this.documents.map(function(doc) {
        return doc.url;
      });
      const zip = new JSZip();
      let count = 0;
      const zipFilename = `${this.newsFeedData.title}.zip`;
      urls.forEach(async function(url) {
        const urlArr = url.split("/");
        const filename = urlArr[urlArr.length - 1];
        try {
          const file = await JSZipUtils.getBinaryContent(url);
          zip.file(filename, file, { binary: true });
          count++;
          if (count === urls.length) {
            zip.generateAsync({ type: "blob" }).then(function(content) {
              saveAs(content, zipFilename);
            });
          }
        } catch (err) {
          console.log(err);
        }
      });
      this.$store.dispatch("user/setSnack", "Documents are downloading!");
      this.$store.dispatch("user/setType", "info");
    }
  }
};
</script>

<style lang="scss" scoped>
.v-icon:hover,
.download-all:hover {
  color: #fcae00 !important;
}
.download-box {
  border: 1px solid #ccc;
  border-radius: 32px;
  padding: 0px 0px;
  margin: 5px;
  height: 12px;
  padding-left: 12px !important;
}
.document-title {
  font-size: 1.1rem;
  font-weight: 500;
}
</style>
